export type PotentialProduct =
  | ProductItemWithProductData
  | FlattenedProduct
  | { id: string | undefined; name: string | undefined }

export const isFlattenedProduct = (product: PotentialProduct): product is FlattenedProduct => {
  return product && 'id' in product && 'name' in product
}

export const isBasketProduct = (product: PotentialProduct): product is ProductItemWithProductData => {
  return product && 'itemId' in product && 'productId' in product
}

export const alignProductType = (product: PotentialProduct) => {
  if (isFlattenedProduct(product)) {
    return { ...product, priceAdjustment: undefined }
  }
  if (isBasketProduct(product)) {
    return {
      id: product.productId ?? '',
      name: product.productName,

      image: product.image,
      inventory: product.inventory,
      itemId: product.itemId,
      price: product.price,
      priceAdjustment: product.priceAdjustments,
      productEngravingText: product.c_engravingText,
      productOptionItems: product.optionItems,
      productPromotions: product.productPromotions,
      slugUrl: undefined,
      tieredPrices: product.productPrices,
      variationAttributes: product.variationAttributes,
      variationValues: product.variationValues,

      c_availableForClickAndCollect: product.productCustomAttributes?.c_availableForClickAndCollect,
      c_coreSize: product.productCustomAttributes?.c_coreSize,
      c_disableFindInStore: product.productCustomAttributes?.c_disableFindInStore,
      c_replenished: product.productCustomAttributes?.c_replenished,
      c_ringSize: product.c_ringSize,
      c_pcpEligibleProduct: product.productCustomAttributes?.c_pcpEligibleProduct, // Set at parent level in PIM, so all variants should inherit and doesn't need to be dynamic
      c_specialOrderLeadTime: product.productCustomAttributes?.c_specialOrderLeadTime,
      c_sourcedExternally: product.productCustomAttributes?.c_sourcedExternally,

      // everything below here is really just for datalayers benefit, dont want to spread the entire productCustomAttributes object as it breaks intellisense and inference
      c_bvAverageRating: product.productCustomAttributes?.c_bvAverageRating,
      c_metalColour: product.productCustomAttributes?.c_metalColour,
      c_mHJRetailCategory: product.productCustomAttributes?.c_mHJRetailCategory,
      c_mHJPrimaryCategory: product.productCustomAttributes?.c_mHJPrimaryCategory,
      c_mHJSubCategory: product.productCustomAttributes?.c_mHJSubCategory,
      options: product.options,
    }
  }
  return {
    id: product.id,
    name: product.name,
  }
}
